import { render, staticRenderFns } from "./BranchAll.vue?vue&type=template&id=200d86b5&"
import script from "./BranchAll.vue?vue&type=script&lang=js&"
export * from "./BranchAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports